const SET_STATUS = 'SET_STATUS'
const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
const SET_CODE_DATA = 'SET_CODE_DATA'

const state = {
  status: '', //create / edit
  activeTab: '',
  codeData: {},
}

const mutations = {
  [SET_STATUS]: (state, value) => {
    state.status = value
  },
  [SET_ACTIVE_TAB]: (state, value) => {
    state.activeTab = value
  },
  [SET_CODE_DATA]: (state, value) => {
    state.codeData = value
  },
}

const actions = {
  setStatus({ commit }, val) {
    commit(SET_STATUS, val)
  },
  setActiveTab({ commit }, val) {
    commit(SET_ACTIVE_TAB, val)
  },
  setCodeData({ commit }, val) {
    commit(SET_CODE_DATA, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}